import { createStyles } from 'utils/css'

export const containerStyle = createStyles(() => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '24px'
}))
